/* eslint-disable */
import {
  bus
} from '@/main';
const $ = window.jQuery = require('jquery');  
export default {
  name: 'ai-algorithms-page',
  components: {},
  props: [],
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {
    bus.$emit('showHeaderbtn', false);
  },
  methods: {

  },
  beforeCreate: function() {
    $('body').addClass('left_sidebaar_disabled_for_page')
    $('body').addClass('public_page_for_wrp_img')
  },
  beforeRouteLeave: function (to, from, next) {
    $('body').removeClass('left_sidebaar_disabled_for_page')
    $('body').removeClass('public_page_for_wrp_img')
    $(window).scrollTop(0);
    next();
  },
}